import { DrawerBody } from '@growtherapy/sprout-ui';

import { ClientInformationDrawerBodyContentWrapper as ClientInformationDrawerBodyContent } from './ClientInformationDrawerBodyContentWrapper';

export function ClientInformationDrawerBody({ isEmpty }: { isEmpty: boolean }) {
  return (
    <>
      <DrawerBody>
        <ClientInformationDrawerBodyContent isEmpty={isEmpty} />
      </DrawerBody>
    </>
  );
}

export function ClientInformationDrawerBodyWrapper({ isEmpty }: { isEmpty: boolean }) {
  return <ClientInformationDrawerBody isEmpty={isEmpty} />;
}
